import * as React from "react"
import Box from "@mui/material/Box"
import Collapse from "@mui/material/Collapse"
import IconButton from "@mui/material/IconButton"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Paper from "@mui/material/Paper"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import { Stack } from "@mui/material"

function createData(
  name: number,
  calories: number,
  fat: number,
  carbs: number,
  protein: number,
  price: number,
  history: any,
) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    price,
    history: [
      {
        date: "2020-01-05",
        customerId: "11091700",
        amount: 3,
      },
    ],
  }
}

function Row(props: { row: ReturnType<typeof createData> }) {
  const { row } = props
  const [open, setOpen] = React.useState(false)

  return (
    <React.Fragment>
      <TableRow
        onClick={() => setOpen(!open)}
        sx={{
          "& > *": { borderBottom: "unset" },

          bgcolor: open ? "background.default" : "unset",
          borderTop: "10px solid rgba(250, 250, 250, 1)",
          m: 0,
          cursor: "pointer",
        }}
      >
        <TableCell>{row.name}</TableCell>
        <TableCell align="center">{row.calories}</TableCell>
        <TableCell align="center">{row.fat}</TableCell>
        <TableCell align="center">{row.carbs}</TableCell>
        <TableCell align="center">{row.protein}</TableCell>
        <TableCell align="center">{row.protein}</TableCell>

        <TableCell>
          <Stack
            justifyContent={"space-between"}
            alignItems={"center"}
            direction={"row"}
          >
            {row.protein}
            <IconButton aria-label="expand row" size="small">
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>
      <TableRow sx={{ bgcolor: "background.default" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0 }}>
              <Table size="small" aria-label="purchases">
                <TableBody sx={{ width: "100%" }}>
                  {row.history.map((historyRow) => (
                    <TableRow key={historyRow.date}>
                      <TableCell align="center">{historyRow.date}</TableCell>
                      <TableCell align="center">{row.calories}</TableCell>
                      <TableCell align="center">{row.fat}</TableCell>
                      <TableCell align="center">{row.carbs}</TableCell>
                      <TableCell align="center">{row.protein}</TableCell>
                      <TableCell align="center">{row.protein}</TableCell>
                      <TableCell align="center">{row.protein}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

const rows = [
  createData(159, 159, 6.0, 24, 4.0, 3.99, 159),
  createData(157, 237, 9.0, 37, 4.3, 4.99, 157),
  createData(112, 262, 16.0, 24, 6.0, 3.79, 112),
  createData(305, 305, 3.7, 67, 4.3, 2.5, 305),
  createData(356, 356, 16.0, 49, 3.9, 1.5, 356),
]

const header = [
  { name: "Неделя", width: "300px" },
  { name: "Кол-во графиков", width: "auto" },
  { name: "Привели на собеседование", width: "auto" },
  { name: "Обучение", width: "auto" },
  { name: "Вывели в линию", width: "auto" },
  { name: "Процент отсева", width: "auto" },
  { name: "Кол-во графиков осталось", width: "auto" },
]

export default function WeekStaststicRow() {
  return (
    <TableContainer
      sx={{
        mt: "20px",
        border: (theme) =>
          theme.palette.mode === "dark"
            ? "1px solid rgba(242, 242, 242, 0.2)"
            : "1px solid rgba(23, 23, 23, 0.2)",
        px: "10px",

        bgcolor: "background.paper",
        borderRadius: "4px",
      }}
      elevation={0}
      component={Paper}
    >
      <Table aria-label="collapsible table">
        <TableHead
          sx={{
            borderTop: "10px solid #FAFAFA",
            borderRadius: "4px",
            bgcolor: "background.default",

            height: "67px",
          }}
        >
          {header.map((item) => (
            <TableCell
              key={item.name}
              sx={{
                fontSize: "14px",
                // minWidth: item.width,
                lineHeight: "1.2",
                fontWeight: "bold",

                height: "57px",
              }}
            >
              {item.name}
            </TableCell>
          ))}
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <Row key={row.name} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
